import { createAuthenticatedApi } from '../api';
import { AllowedGroup, AllowedGroupsResponse } from '../models/allowedGroup';

/**
 * Fetch all allowed groups organized by airline
 */
export const fetchAllowedGroups = async (token: string): Promise<AllowedGroupsResponse> => {
  try {
    const api = createAuthenticatedApi(token);
    const response = await api.get('/AllowedGroups');
    return response.data;
  } catch (error) {
    console.error('Error fetching allowed groups:', error);
    throw error;
  }
};

/**
 * Fetch allowed groups for a specific airline
 */
export const fetchAllowedGroupsByAirline = async (token: string, airline: string): Promise<string[]> => {
  try {
    const api = createAuthenticatedApi(token);
    const response = await api.get(`/AllowedGroups/airline/${airline}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching allowed groups for airline ${airline}:`, error);
    throw error;
  }
};

/**
 * Fetch all allowed groups with full details (for admin management)
 */
export const fetchAllAllowedGroups = async (token: string): Promise<AllowedGroup[]> => {
  try {
    const api = createAuthenticatedApi(token);
    const response = await api.get('/AllowedGroups/all');
    return response.data;
  } catch (error) {
    console.error('Error fetching all allowed groups:', error);
    throw error;
  }
};

/**
 * Fetch distinct airlines from allowed groups
 */
export const fetchAirlines = async (token: string): Promise<string[]> => {
  try {
    const api = createAuthenticatedApi(token);
    const response = await api.get('/AllowedGroups/airlines');
    return response.data;
  } catch (error) {
    console.error('Error fetching airlines:', error);
    throw error;
  }
};

/**
 * Create a new allowed group
 */
export const createAllowedGroup = async (token: string, group: AllowedGroup): Promise<AllowedGroup> => {
  try {
    const api = createAuthenticatedApi(token);
    const response = await api.post('/AllowedGroups', group);
    return response.data;
  } catch (error) {
    console.error('Error creating allowed group:', error);
    throw error;
  }
};

/**
 * Update an existing allowed group
 */
export const updateAllowedGroup = async (token: string, id: number, group: AllowedGroup): Promise<AllowedGroup> => {
  try {
    const api = createAuthenticatedApi(token);
    const response = await api.put(`/AllowedGroups/${id}`, group);
    return response.data;
  } catch (error) {
    console.error('Error updating allowed group:', error);
    throw error;
  }
};

/**
 * Delete an allowed group
 */
export const deleteAllowedGroup = async (token: string, id: number): Promise<void> => {
  try {
    const api = createAuthenticatedApi(token);
    await api.delete(`/AllowedGroups/${id}`);
  } catch (error) {
    console.error('Error deleting allowed group:', error);
    throw error;
  }
};
